<template>
    <div class="document-container">
        <div class="edit-document-button" v-if="$store.state.is_manager">
            <el-button type="primary" @click="editorDocument" icon="el-icon-edit" class="circle-button"
                       title="编辑"></el-button>
        </div>
        <a class="el-link el-link--danger is-underline" @click="centerDialogVisible = true">
            <span class="el-link--inner">如果图片无法显示，请点击。（Click here to refresh the image.）</span>
        </a>
        <div class="document-title">
            <p class='documentTitle' v-text="title"></p>
        </div>
        <div class="document-content" ref="contentWrapper">
        </div>

        <el-dialog title="学城图片认证（Citadel Image Verification）" :visible.sync="centerDialogVisible" width="500px" center :show-close="false">
            <iframe src="https://km.sankuai.com/api/file/cdn/277659316/277785340?contentType=1&isNewContent=true&isNewContent=false"
                    class="iframe">
            </iframe>
            <div class="success-message">认证成功（Verified）</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeDialogFun">确 定（Confirm）</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import axios from "axios";
    import {mapState} from "vuex";
    import {imageToView} from '@mtfe/citadel-editor/es/image'

    export default {
        name: "templateHtml",
        beforeRouteUpdate(to, from, next) {
            this.currentIndex = to.query.index;
            window.scrollTo(0, 0);
            next();
        },
        mounted: function () {
            var vm = this;
            vm.currentIndex = vm.$route.query.index;
            if (vm.token == "") {
                var token = this.getCookie("access-token");
                if (token != null) {
                    vm.$store.commit('UPDATETOKEN', token);
                    vm.token = token;
                }
            }
            vm.$store.commit('changeActiveItem', vm.currentIndex);
            axios.get(vm.selectDocument, {
                withCredentials: true,
                params: {"documentIndex": vm.currentIndex, "language": ""},
            }).then((response) => {
                if (response.data && response.data.status === 401) {
                    document.cookie = "currentURL=templateHtml?index=" + vm.currentIndex;
                    window.location = vm.loginRediret;
                    return;
                }
                if (response.data.code === 2) {
                  if (response.data.message !== '查询成功') {
                    vm.$notify({
                      title: '提示(Notice)',
                      message: "无对应语言页面，显示当前页面～(No corresponding language page available, displaying the current page~)",
                      type: 'warning',
                      customClass: 'notify-warning'
                    });
                  }
                    vm.documentContent = response.data.data.documentContent;
                    vm.$refs.contentWrapper.innerHTML = vm.documentContent;
                    vm.title = response.data.data.documentTitle;
                    console.log(response.data.data.language);
                    this.$store.commit('UPDATE_LANGUAGE', response.data.data.language);
                    imageToView({
                        bodyWrapper: vm.$refs.contentWrapper
                    }, {
                        imageLink: false
                    });
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '显示文档失败！',
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                vm.requesterrorinfo(error)
            });
        }
        ,
        computed: mapState({
            loginRediret: function (state) {
                return state.loginRediret;
            },
            selectDocument: function (state) {
                return state.selectDocument;
            },
            selectItemList: function (state) {
                return state.selectItemList;
            },
            cookieName: function (state) {
                return state.cookieName;
            },
          ...mapState({
            currentLang: state => state.currentLang
          })
        }),
        methods: {
            closeDialogFun() {
                this.centerDialogVisible = false;
                window.location.reload();
            },
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
            editorDocument() {
                if (!(this.$store.state.is_manager)) {
                    this.$notify({
                        title: '没有权限',
                        message: '你没有操作当前菜单的权限',
                        type: 'error'
                    });
                    return;
                }
                this.$router.push({
                    path: '/updateDocument',
                    query: {index: this.currentIndex}
                });
            },
            refreshHtmlWhenLangChange(index) {
                var vm = this;
                axios.get(vm.selectDocument, {
                    withCredentials: true,
                    params: {"documentIndex": index.query.index, "language": vm.currentLang},
                }).then((response) => {
                    if (response.data && response.data.status === 401) {
                        document.cookie = "currentURL=templateHtml?index=" + vm.currentIndex;
                        window.location = vm.loginRediret;
                        return;
                    }
                    if (response.data.code === 2) {
                      if (response.data.message !== '查询成功') {
                        vm.$notify({
                            title: '提示(Notice)',
                            message: "无对应语言页面，显示当前页面～(No corresponding language page available, displaying the current page~)",
                            type: 'warning',
                            customClass: 'notify-warning'
                        });
                        this.$store.commit('UPDATE_LANGUAGE', response.data.data.language);
                      }
                        vm.documentContent = response.data.data.documentContent;
                        vm.$refs.contentWrapper.innerHTML = vm.documentContent;
                        vm.title = response.data.data.documentTitle;
                        imageToView({
                            bodyWrapper: vm.$refs.contentWrapper
                        }, {
                            imageLink: false
                        });
                    } else {
                        let message = '显示文档失败！';
                        if (response.data && response.data.message) {
                            message = response.data.message + '!';
                        }
                        vm.$notify({
                            title: '提示',
                            message: message,
                            type: 'error'
                        });
                    }
                }).catch(function (error) {
                    vm.requesterrorinfo(error)
                });
            },
          refreshHtml(index) {
            var vm = this;
            axios.get(vm.selectDocument, {
              withCredentials: true,
              params: {"documentIndex": index.query.index, "language": ""},
            }).then((response) => {
              if (response.data && response.data.status === 401) {
                document.cookie = "currentURL=templateHtml?index=" + vm.currentIndex;
                window.location = vm.loginRediret;
                return;
              }
              if (response.data.code === 2) {
                if (response.data.message !== '查询成功') {
                  vm.$notify({
                    title: '提示(Notice)',
                    message: "无对应语言页面，显示当前页面～(No corresponding language page available, displaying the current page~)",
                    type: 'warning',
                    customClass: 'notify-warning'
                  });
                }
                vm.documentContent = response.data.data.documentContent;
                vm.$refs.contentWrapper.innerHTML = vm.documentContent;
                vm.title = response.data.data.documentTitle;
                console.log(response.data.data.language);
                this.$store.commit('UPDATE_LANGUAGE', response.data.data.language);

                imageToView({
                  bodyWrapper: vm.$refs.contentWrapper
                }, {
                  imageLink: false
                });
              } else {
                let message = '显示文档失败！';
                if (response.data && response.data.message) {
                  message = response.data.message + '!';
                }
                vm.$notify({
                  title: '提示',
                  message: message,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              vm.requesterrorinfo(error)
            });
          },
            requesterrorinfo(error) {
                var vm = this;
                if (error.response) {
                    var code = error.response.status;
                    if (code == 401) {
                        document.cookie = "currentURL=templateHtml?index=" + vm.currentIndex;
                        window.location = vm.loginRediret;
                    } else {
                        if (code == 404) {
                            vm.$notify({
                                title: '提示',
                                message: '404:Not found!',
                                type: 'error'
                            });
                        } else {
                            vm.$notify({
                                title: '提示',
                                message: '501:服务端未响应!',
                                type: 'error'
                            });
                        }
                    }
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '502:服务端未响应!',
                        type: 'error'
                    });
                }
            },
          updateComponentLanguage(lang) {
            // 根据语言更新组件内容
            const index = {
              query: {
                index: this.currentIndex
              }
            };
            this.refreshHtmlWhenLangChange(index);
          }
        },
        watch: {
          $route: "refreshHtml",
          currentLang(newLang) {
            // 当语言改变时执行相应操作
            this.updateComponentLanguage(newLang);
          }
        },
        data() {
            return {
                token: '',
                currentIndex: '',
                documentContent: '',
                title: '',
                centerDialogVisible: false
            }
        }
    }
</script>

<style scoped>
    .documentTitle {
        margin: 16px 0 8px;
        padding: 0 30px;
        border: 0;
        font-size: 32px !important;
        font-weight: 700;
        background: none;
        resize: none;
    }

    .edit-document-button {
        position: fixed;
        top: 100px;
        right: 60px;
    }

    .el-button.circle-button {
        padding: 12px !important;
        border-radius: 50% !important;
    }

    .el-link {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        vertical-align: middle;
        position: relative;
        text-decoration: none;
        outline: none;
        cursor: pointer;
        padding: 0;
        font-size: 14px;
        font-weight: 500;
    }

    .el-link.el-link--danger {
        color: #f56c6c;
    }

    .el-link.el-link--danger.is-underline:hover {
        text-decoration: underline;
        text-decoration-color: #f56c6c
    }

    .el-dialog__body {
        height: 300px;
        padding: 0;
    }

    .iframe {
        width: 0;
        height: 0;
        overflow: hidden;
    }

    div.success-message {
        font-size: 36px;
        font-weight: bold;
        display: block;
        position: relative;
        height: 100px;
        line-height: 100px;
        top: -15px;
        background-color: #fff;
        text-align: center;
    }
</style>









// WEBPACK FOOTER //
// templateHtml.vue?6539f571